import React,{useEffect, useState} from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/esm/Dropdown";
import { Col, Row, Button } from "antd";
import { environment } from "../Environment";
import * as microsoftTeams from "@microsoft/teams-js";

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 */
export const NewSignInButton = () => {
    const [loading,setLoading]= useState(false);
    const { instance } = useMsal();   
    const getClientSideToken=()=>{
        return new Promise((resolve,reject)=>{
            microsoftTeams.authentication.getAuthToken().then((result)=>{
                resolve(result);
            }).catch((error)=>{
                reject("Error getting Token:" + error);
            })
        });
    }
    const handleSsoResponse=(response)=>{
        if (!!response.account.username) {
            var encusername = btoa(response.account.username)
            encusername = btoa(encusername)
    
            window.location = `${environment.url.AUTH_URL}/Account/SsoSpaLogin?ssologintoken=${encusername}`;
           //  document.querySelector('body').append(`<p style="color:'yellow';position:fixed;bottom:0;left:0" }> in teams</p>`);
        }
    }
    const msalSsoLogin =( channel, token)=>{
        if(channel=="Teams" && !!token){
            const [header,payload,signature]= token.split(".");
            const bs64= payload.replace(/-/g,'+').replace(/_/g,'/');
            const decodedPl= atob(bs64);
            let tokenJson= JSON.parse(decodedPl);
            var encusername = btoa(tokenJson.preferred_username?.toLowerCase()??tokenJson.unique_name?.toLowerCase());
            encusername = btoa(encusername)
            window.location = `${environment.url.AUTH_URL}/Account/SsoSpaLogin?ssologintoken=${encusername}&channel=Teams`;
        }else{
            instance.ssoSilent({
                scopes:["User.Read"]
            }).then(
                (response)=>{
                    console.log(channel+" sso Success");
                    setLoading(false);
                    handleSsoResponse(response)
                }
            ).catch((err)=>{
                console.log(channel+ " Sso Silent Login Failed", err)
                instance.loginPopup({
                    scopes:["User.Read"],
                }).then((response)=>{
                    // console.log(channel +" Sso Login Success >" ,response);
                    setLoading(false);
                    handleSsoResponse(response)
                }).catch((error)=>{
                    console.error(channel+" SSO Failed :" + JSON.stringify(error));
                    setLoading(false);
                    
                })
            })
        }
    }
    const handleLogin = () => {
        setLoading(true);
        microsoftTeams.app.initialize().then(()=>{
         microsoftTeams.app.getContext().then((ctx)=>{
            if(ctx){
                getClientSideToken().then((token)=>{
                    // console.log("token >>>",token)
                    msalSsoLogin("Teams",token);
                }).catch((error)=>{
                    console.error("Teams SSO Error :" +JSON.stringify(error))
                    msalSsoLogin("Web");
                    setLoading(false)
                })
            }
         })

        })
        .catch((err)=>{
           console.log("Teams App Not Initailized : " , err);
           msalSsoLogin("Web");
           setLoading(false)
        })
    }
    return (
        <>
            <Row>
                <Col>
                    <Button type="primary" loading={loading} onClick={() => handleLogin()}>Sign In</Button>
                </Col>
                {/* <Col></Col>
                <Col>
                    <Button type="primary" onClick={() => handleLogin("redirecttoauth")}>Supplier Sign In</Button>
                </Col> */}
            </Row>

            <DropdownButton variant="secondary" className="ml-auto" drop="left" title="Sign In" style={{ display: 'none' }}>
                <Dropdown.Item as="button" onClick={() => handleLogin("popup")}>Sign in using Popup</Dropdown.Item>
                <Dropdown.Item as="button" onClick={() => handleLogin("redirect")}>Sign in using Redirect</Dropdown.Item>
            </DropdownButton>
        </>
    )
}